import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Ekey",
    component: () =>
        __SERVER__ ? require("./profile-activate-ekey-view") : import("./profile-activate-ekey-view")
});

export default definition;
